<template>
  <el-config-provider :locale="locale" >
    <slot></slot>
  </el-config-provider>
</template>
<script setup>
  import { computed } from 'vue'

  import zhCn from 'element-plus/dist/locale/zh-cn.mjs'
  import en from 'element-plus/dist/locale/en.mjs'
  import store from '@store/index'

  const locale = computed(() => {
    switch (store.state.lan) {
      case 'zh-cn':
        return zhCn
      case 'en':
        return en
      default:
        return zhCn
    }
  })
</script>
